import React from "react";
import { Box } from "@mui/system";
import Loader from "components/loader";
import { Pagination, ReducersModal } from "utils/modals";
import { useDispatch, useSelector } from "react-redux";
import { deleteCompany, getCarCompanyList } from "./action";
import AddNewCompanyModal from "modules/utilityManagement/addNewCompany";
import CarCompanyTable from "components/tables/carCompanyTable";
import { UPDATE_CAR_LIST_REDUCER } from "store/actionTypes";

const Company = () => {
  const dispatch: any = useDispatch();
  const { carCompanies } = useSelector(
    (state: ReducersModal) => state.CarCompanyReducer
  );

  const [open, setOpen] = React.useState(false);
  const [selectedCompany, setSelectedCompany] = React.useState(null);
  const { isLoading, result = [], search = "" } = carCompanies;
  const pagination = carCompanies?.pagination ?? new Pagination();
  const { page, limit } = pagination;

  React.useEffect(() => {
    dispatch(getCarCompanyList(() => {}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search]);

  const dispatchValue = (payload: any) => {
    dispatch({
      type: UPDATE_CAR_LIST_REDUCER,
      payload,
    });
  };
  const handleChangePage = (newPage: any) => {
    dispatchValue({
      carCompanies: {
        ...carCompanies,
        pagination: { ...pagination, page: newPage + 1 },
      },
    });
  };

  const handleChangeRowsPerPage = (value: any) => {
    dispatchValue({
      carCompanies: {
        ...carCompanies,
        pagination: { ...pagination, page: 1, limit: value },
      },
    });
  };

  const searchHandler = (text: string) => {
    const nextSearch = `${text || ""}`.trim();
    dispatchValue({
      carCompanies: {
        ...carCompanies,
        search: nextSearch,
        pagination: { ...pagination, page: 1 },
      },
    });
  };

  const onEditPress = (company: any) => {
    setSelectedCompany(company);
    setOpen(true);
  };
  const onDeletePress = (company: any) => {
    dispatch(deleteCompany({ callback: () => {}, data: { id: company.id } }));
  };

  return (
    <Box>
      <CarCompanyTable
        carCompaniesList={result}
        currentPage={pagination.page}
        onEditPress={onEditPress}
        onDeletePress={onDeletePress}
        onAddPress={() => {
          setSelectedCompany(null);
          setOpen(true);
        }}
        rowsPerPage={pagination.limit}
        handleChangePage={handleChangePage}
        totalRecords={pagination.totalRecords}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        searchHandler={searchHandler}
      />
      <AddNewCompanyModal
        selectedCompany={selectedCompany}
        state={open}
        setState={setOpen}
      />
      {isLoading && <Loader />}
    </Box>
  );
};
export default Company;
